module.exports = __webpack_public_path__ + "img/www.classpass.com.adb323cc.png";